import { combineReducers } from "redux";
import constant from "lodash-es/constant";

import createReducer from "../../utils/createReducer";

import {
  REQUEST_STATEMENTS,
  REQUEST_STATEMENTS_SUCCESS,
  REQUEST_STATEMENTS_FAIL,
  REQUEST_STATEMENTS_ITEM_SUCCESS,
  REQUEST_STATEMENTS_ITEM_FAIL,
  CLEAR_STATEMENTS_ERROR,
  REQUEST_RELOAD_STATEMENTS,
  REQUEST_RELOAD_STATEMENTS_SUCCESS,
  REQUEST_RELOAD_STATEMENTS_FAIL
} from "./actionTypes";

// Current
const currentCase = createReducer(null, {
  [REQUEST_STATEMENTS]: (state, { payload }) => payload,
  [CLEAR_STATEMENTS_ERROR]: constant(null)
});

// Data
const data = createReducer(null, {
  [REQUEST_STATEMENTS_SUCCESS]: (state, { payload }) => payload,
  [REQUEST_RELOAD_STATEMENTS_SUCCESS]: (state, { payload }) => payload,
  [REQUEST_STATEMENTS]: constant(null),
  [CLEAR_STATEMENTS_ERROR]: constant(null)
});

const galleryItems = createReducer(
  {},
  {
    [REQUEST_STATEMENTS_ITEM_SUCCESS]: (state, { payload }) => ({
      ...state,
      [payload.id]: payload
    })
  }
);

const error = createReducer(null, {
  [REQUEST_STATEMENTS]: constant(null),
  [CLEAR_STATEMENTS_ERROR]: constant(null),
  [REQUEST_STATEMENTS_FAIL]: (state, { payload }) => payload,
  [REQUEST_STATEMENTS_ITEM_FAIL]: (state, { payload }) => payload
});

const isLoading = createReducer(false, {
  [REQUEST_STATEMENTS]: constant(true),
  [REQUEST_STATEMENTS_SUCCESS]: constant(false),
  [REQUEST_STATEMENTS_FAIL]: constant(false)
});

const isReloading = createReducer(false, {
  [REQUEST_RELOAD_STATEMENTS]: constant(true),
  [REQUEST_RELOAD_STATEMENTS_SUCCESS]: constant(false),
  [REQUEST_RELOAD_STATEMENTS_FAIL]: constant(false)
});

export default combineReducers({
  currentCase,
  data,
  error,
  isLoading,
  galleryItems,
  isReloading
});
